/* __next_internal_client_entry_do_not_use__ Button auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Children, forwardRef } from 'react';
import { Role } from '@ariakit/react';
import cx from 'classnames';
import { trackEvent } from '~/ui/components/analytics';
import typographyStyles from '~/ui/styles/typography.module.scss';
import { invariant } from '~/utils/invariant';
import styles from './button.module.scss';
import { ButtonSize, ButtonVariant } from './types';
export const Button = /*#__PURE__*/ forwardRef(ButtonImpl);
function ButtonImpl(param, forwardedRef) {
    let { size = ButtonSize.REGULAR, variant = ButtonVariant.PRIMARY, event, className, onClick, ...props } = param;
    // This is buggy with the async button
    invariant(size === ButtonSize.ICON ? Children.count(props.children) === 1 : true, 'multiple children provided to icon button');
    return /*#__PURE__*/ _jsx(Role.button, {
        ...props,
        className: cx(styles.button, typographyStyles.button, className, {
            [styles.primary]: variant === ButtonVariant.PRIMARY,
            [styles.secondary]: variant === ButtonVariant.SECONDARY,
            [styles.secondaryTransparent]: variant === ButtonVariant.SECONDARY_TRANSPARENT,
            [styles.large]: size === ButtonSize.REGULAR,
            [styles.small]: size === ButtonSize.TINY,
            [styles.icon]: size === ButtonSize.ICON
        }),
        onClick: (e)=>{
            if (event) {
                trackEvent(event);
            }
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        },
        ref: forwardedRef
    });
}
